export enum ClockRegisterTypeEnum {
  IN = 'in',
  OUT = 'out',
}

export function getClockRegisterTypeLabel(type: ClockRegisterTypeEnum): string {
  return type === ClockRegisterTypeEnum.IN ? 'Entrada' : 'Salida';
}
